import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<circle cx=\"20\" cy=\"20\" r=\"20\" fill=\"#D2F9E6\"></circle><path opacity=\"0.4\" d=\"M26.04 21.55C25.62 21.96 25.38 22.55 25.44 23.18C25.53 24.26 26.52 25.05 27.6 25.05H29.5V26.24C29.5 28.31 27.81 30 25.74 30H14.26C12.19 30 10.5 28.31 10.5 26.24V19.51C10.5 17.44 12.19 15.75 14.26 15.75H25.74C27.81 15.75 29.5 17.44 29.5 19.51V20.95H27.48C26.92 20.95 26.41 21.17 26.04 21.55Z\" fill=\"#09926C\"></path><path d=\"M22.85 11.95V15.75H14.26C12.19 15.75 10.5 17.44 10.5 19.51V15.84C10.5 14.65 11.23 13.59 12.34 13.17L20.28 10.17C21.52 9.70997 22.85 10.62 22.85 11.95Z\" fill=\"#09926C\"></path><path d=\"M30.5588 21.9699V24.03C30.5588 24.58 30.1188 25.0299 29.5588 25.0499H27.5988C26.5188 25.0499 25.5288 24.2599 25.4388 23.1799C25.3788 22.5499 25.6188 21.9599 26.0388 21.5499C26.4088 21.1699 26.9188 20.95 27.4788 20.95H29.5588C30.1188 20.97 30.5588 21.4199 30.5588 21.9699Z\" fill=\"#09926C\"></path><path d=\"M22 20.75H15C14.59 20.75 14.25 20.41 14.25 20C14.25 19.59 14.59 19.25 15 19.25H22C22.41 19.25 22.75 19.59 22.75 20C22.75 20.41 22.41 20.75 22 20.75Z\" fill=\"#09926C\"></path>", 5)
const _hoisted_7 = [
  _hoisted_2
]

import { withDefaults } from 'vue';
        
        interface IProps {
          color?: string;
        }
        
        
export default /*#__PURE__*/_defineComponent({
  __name: 'EmpityWallet',
  props: {
    color: {}
  },
  setup(__props: any) {

        const props = __props;
        
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_7))
}
}

})